import Page from "../landing/pages/en"

export default Page
